import { TableContainer } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import AvatarGroup from "@material-ui/lab/AvatarGroup";
import Pagination from "@material-ui/lab/Pagination";
import Tooltip from "@mui/material/Tooltip";
import sortImg from "assets/icons/sort-able-svg.svg";
import { MyCheckbox } from "components";
import Action from "components/ActionPopOver";
import Loader from "components/loader/Loader";
import { formatDate } from "helper/dateFormat";
import React from 'react';
import { useHistory } from "react-router";
import { fontConfig } from "theme/fontConfig";

const TableCellHead = withStyles((theme) => ({
  root: {
    height: "39px",
    padding: "0px 20px",
    borderBottom: "none",
    fontFamily: fontConfig.GeneralTableCellHeadFont.family,
    paddingLeft: "20px !important",
  },
}))(TableCell);

const TableCellBody = withStyles((theme) => ({
  root: {
    height: "65px",
    padding: "0px 20px",
    fontFamily: fontConfig.GeneralTableCellBodyFont.family,
    fontSize: "12px",
    color: "#4F4F4F",
  },
}))(TableCell);


const DeceasedTableList = ({
  list,
  loading,
  total,
  page,
  setPage,
  checkAll,
  check,
  setCheckAll,
  setCheck,
  onCheckboxClick,
  setFilters,
  setOpenModal,
  setOpen,
  setMournersList,
  setDeceasedId,
  setOpenAddMournerModal,

}) => {
  const history = useHistory();

  const columns = [
    {
      id: "checkbox",
      label: (<div className="header__checkbox">
        <MyCheckbox
          handlechange={(e) => {
            const { checked } = e?.target;
            setCheckAll(checked);
            setCheck([]);
          }}
          checked={checkAll}

        />
      </div>),
    },
    {
      id: "firstName",
      label: "DECEASED FIRST NAME",
      sortable: true,
      sortableAction: () => {
        setFilters((prev) => ({
          ...prev,
          sort: {
            firstName: prev?.sort?.firstName == 1 ? -1 : 1,
          },
        }));
      }
    },
    {
      id: "lastName",
      label: "DECEASED LAST NAME",
      sortable: true,
      sortableAction: () => {
        setFilters((prev) => ({
          ...prev,
          sort: {
            lastName: prev?.sort?.lastName == 1 ? -1 : 1,
          },
        }));
      },
    },
    {
      id: "date_of_death",
      label: "DATE OF DEATH",
      sortable: true,
      sortableAction: () => {
        setFilters((prev) => ({
          ...prev,
          sort: {
            date_of_death: prev?.sort?.date_of_death == 1 ? -1 : 1,
          },
        }));
      },
    },
    {
      id: "eng-mourners",
      label: "OBSERVERS",
    },
    {
      id: "hebrew_date",
      label: "DATE OF DEATH (HEBREW)",
      sortable: true,
      sortableAction: () => {
        setFilters((prev) => ({
          ...prev,
          sort: {
            hebrew_date_of_death: prev?.sort?.hebrew_date_of_death == 1 ? -1 : 1,
          },
        }));
      }
    },
    {
      id: "heb-mourners",
      label: "OBSERVERS (HEBREW DATE)",
    },
    {
      id: "next_english_yhartzeit",
      label: "NEXT ENGLISH YAHRZEIT",
    },
    {
      id: "next_hebrew_yhartzeit",
      label: "NEXT HEBREW YAHRZEIT",
    },
    {
      id: "plaque_number",
      label: "PLAQUE NUMBER",
    },
    {
      id: "sent",
      label: "SENT",
    },
    {
      id: "action",
      label: "Action",
      className: "sticky-header-column",
    },
  ];

  return (
    <div
      className=""
    >
      <div>
        <TableContainer className="scroll-table">
          <Table
            class="main-tables"
            aria-label="collapsible table"
            style={{ width: "100%" }}
          >
            <TableHead className="charges-table sticky-table-header">
              <TableRow>
                {columns?.map((column) => (
                  <TableCellHead
                    key={column.id}
                    align="left" className={`class__header__cell year__head ${column.className}`}
                  >
                    {column?.id !== "action" && (
                      <div className="d-flex h-100 justify-content-start align-items-center" style={{ gap: "10px" }}
                      >
                        {column?.label}
                        {column?.sortable && (
                          <div className="cursor-pointer"
                            onClick={() => column?.sortable ? column.sortableAction() : null}
                          >
                            <img src={sortImg} style={{ marginLeft: "5px" }} />
                          </div>
                        )}
                      </div>
                    )}
                  </TableCellHead>
                ))}
              </TableRow>
            </TableHead>
            <TableBody
              className="tran-table-body"
              style={{
                backgroundColor: "white",
              }}
            >
              {loading ? (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    <div
                      className="user__loader"
                      style={{ height: "320px" }}
                    >
                      <Loader />
                    </div>
                  </TableCell>
                </TableRow>
              ) : list?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    <h6 style={{ height: "320px", marginTop: "100px" }}>
                      No Data Found
                    </h6>
                  </TableCell>
                </TableRow>
              ) : (
                list?.map((row, i) => (
                  <TableRow
                    key={row?.id}
                    sx={{ "& > *": { borderBottom: "unset" } }}
                    onClick={(event) => {
                      console.log('event :', event);
                      setDeceasedId(row?.id);
                      setOpenModal(true);
                    }}
                  >
                    <TableCellBody align="left"
                    >
                      <div
                        style={{
                          color: "#4F4F4F",
                          fontSize: "14px",
                          opacity: checkAll ? 0.5 : 1,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <MyCheckbox
                          handlechange={(e) => {
                            if (checkAll) return;
                            onCheckboxClick(e, row);
                            if (e?.target?.checked) {
                              setCheck((prev) => [...prev, row]);
                            } else {
                              setCheck(
                                check?.filter((item) => item?._id !== row?._id)
                              );
                            }
                          }}
                          checked={
                            checkAll ? true : check?.findIndex((item) => item?._id === row?._id) !== -1
                          }
                          disabled={checkAll}

                        />
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className="user-cotainer-home ml-0 -head pl-0">
                        <div className="user-icon d-flex flex-row">
                          <Avatar
                            className="avatar"
                            style={{
                              height: "50px",
                              borderRadius: "6px",
                              width: "50px",
                            }}
                            alt={`yahrziet`}
                          >
                            <div className="name text-center">
                              {row?.firstName &&
                                `${row?.firstName[0]}`.toUpperCase()}
                            </div>
                          </Avatar>
                        </div>
                        <Tooltip title={`${row?.firstName}`} placement="top">
                          <div className="name-container flex-row-reverse">
                            <p
                              className="id-container w-100 table-field-hover-data text-left"
                              style={{ wordBreak: "break-word", whiteSpace: "normal" }}
                            >
                              {row?.firstName && row?.firstName}
                            </p>
                          </div>
                        </Tooltip>
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className="user-cotainer-home ml-0 -head pl-0">
                        <Tooltip title={`${row?.lastName}`} placement="top">
                          <div className="name-container flex-row-reverse pl-0">
                            <p
                              className="id-container w-100 table-field-hover-data text-left"
                              style={{ wordBreak: "break-word", whiteSpace: "normal" }}
                            >
                              {row?.lastName && row?.lastName}
                            </p>
                          </div>
                        </Tooltip>
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className=" pl-0 ">
                        <div style={{ color: "#4F4F4F", fontSize: "14px" }}>
                          {row?.date_of_death
                            ? formatDate({ date: row?.date_of_death, formatType: "defaultWithUTC" })
                            : "-"}
                        </div>
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div
                        className="w-180"
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        <div style={{ color: "#4F4F4F", fontSize: "14px" }}>
                          <div className="avatar-container my-0 mx-5">
                            <AvatarGroup max={4}>
                              {row?.mourners_list?.map((mourner, index) => {
                                if (mourner.observance === "english")
                                  return (
                                    <Tooltip
                                      title={
                                        mourner?.member_id?.first_name
                                          ? `${mourner?.member_id?.first_name} ${mourner?.member_id?.last_name}`
                                          : "Guest"
                                      }
                                    >
                                      <Avatar
                                        key={index}
                                        alt={mourner?.member_id?.first_name}
                                        src={mourner?.member_id?.profile_img}
                                        onClick={mourner?.member_id?.first_name ? (e) => {
                                          e.stopPropagation();
                                          history.push(`/member-details/${mourner?.member_id?.account?._id}?q=${mourner?.member_id?._id}&tab=Family`);
                                        } : null}
                                        style={{
                                          cursor: "pointer",
                                        }}
                                      >
                                        {mourner?.member_id?.first_name &&
                                          mourner?.member_id?.last_name &&
                                          (
                                            mourner?.member_id.first_name[0] +
                                            mourner?.member_id.last_name[0]
                                          ).toUpperCase()}
                                      </Avatar>
                                    </Tooltip>
                                  );
                              })}
                            </AvatarGroup>
                          </div>
                        </div>
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className=" w-100 ml-0">
                        <div style={{ color: "#4F4F4F", fontSize: "14px" }}>
                          {row?.hebrew_date_of_death
                            ? row?.hebrew_date_of_death
                            : "-"}
                        </div>
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className="w-100">
                        <div className="avatar-container my-0 mx-5">
                          <AvatarGroup max={4}>
                            {row?.mourners_list?.map((mourner, index) => {
                              if (mourner.observance === "hebrew")
                                return (
                                  <Tooltip
                                    title={
                                      mourner?.member_id?.first_name
                                        ? `${mourner?.member_id?.first_name} ${mourner?.member_id?.last_name}`
                                        : "Guest"
                                    }
                                  >
                                    <Avatar
                                      key={index}
                                      alt={mourner?.member_id?.first_name}
                                      src={mourner?.member_id?.profile_img}
                                      onClick={mourner?.member_id?.first_name ? (e) => {
                                        e.stopPropagation();
                                        history.push(`/member-details/${mourner?.member_id?.account?._id}?q=${mourner?.member_id?._id}&tab=Family`);
                                      } : null}
                                      style={{
                                        cursor: "pointer",
                                      }}
                                    >
                                      {mourner?.member_id?.first_name &&
                                        mourner?.member_id?.last_name &&
                                        (
                                          mourner?.member_id.first_name[0] +
                                          mourner?.member_id.last_name[0]
                                        ).toUpperCase()}
                                    </Avatar>
                                  </Tooltip>
                                );
                            })}
                          </AvatarGroup>
                        </div>
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className=" pl-0 ">
                        <div style={{ color: "#4F4F4F", fontSize: "14px" }}>
                          {row?.next_english_yhartzeit
                            ? formatDate({ date: row?.next_english_yhartzeit, formatType: "defaultWithUTC" })
                            : "-"}
                        </div>
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className=" pl-0 ">
                        <div style={{ color: "#4F4F4F", fontSize: "14px" }}>
                          {row?.next_hebrew_yhartzeit
                            ? formatDate({ date: row?.next_hebrew_yhartzeit, formatType: "defaultWithUTC" })
                            : "-"}
                        </div>
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className=" pl-0 ">
                        <div style={{ color: "#4F4F4F", fontSize: "14px" }}>
                          {row?.plaque_number ?? "-"}
                        </div>
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      {(row?.sent?.status === "sent") ? (
                        <span className="d-flex flex-column justify-content-center send__status pl-0"
                          style={{
                            minWidth: "200px",
                          }}
                        >
                          <span className="send__status_value">
                            {row?.sent?.status}
                          </span>
                          <span className="send__status_date">
                            {formatDate({ date: row?.sent?.date, formatType: "defaultWithTime" })}
                          </span>
                        </span>
                      )
                        : ""}
                    </TableCellBody>
                    <TableCellBody align="left" className="sticky-body-column"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <div style={{ cursor: "pointer", paddingRight: "0px" }}>
                        <Action
                          style={{ color: "#4D5565", width: "16px" }}
                          onEditClick={() => {
                            setDeceasedId(row?.id);
                            setOpenModal(true);
                          }}
                          onDeleteClick={() => {
                            setDeceasedId(row?._id);
                            setOpen(true);
                          }}
                          onAddMournerClick={() => {
                            const filteredMourner = row?.mourners_list.map((item) => {
                              return {
                                ...item,
                                memberId: item?.member_id?._id,
                              };
                            });
                            setMournersList(filteredMourner);
                            setDeceasedId(row?._id);
                            setOpenAddMournerModal(true);
                          }}
                        />
                      </div>
                    </TableCellBody>
                  </TableRow>
                )
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div
        className={`w-100 pagination-custom mt-2 mb-4 py-4`}
      >
        <Pagination
          count={Math.ceil(total / 30)}
          color="primary"
          variant="outlined"
          page={page + 1}
          onChange={(event, value) => {
            setPage(value - 1);
          }}
        />
      </div>
    </div>

  )
}

export default DeceasedTableList